import {
  SET_USER,
  ADD_ALERT,
  REMOVE_ALERT,
  SET_APP_JS_LOADED,
  CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES,
  IS_APP_LOADING
} from './definition'

const addBanner = (state, banner) => {
  state.banners.push(banner)
}

const removeBanner = (state, banner) => {
  const idx = state.banners.indexOf(banner)
  if (idx !== -1) {
    state.banners.splice(idx, 1)
  }
}

export default {
  addBanner,
  removeBanner,
  [SET_USER] (state, user) {
    state.user = user
  },
  [ADD_ALERT] (state, alert) {
    state.alerts.push(alert)
  },
  [REMOVE_ALERT] (state, alert) {
    let index = state.alerts.indexOf(alert)
    if (index !== -1) {
      state.alerts.splice(index, 1)
    }
  },
  [SET_APP_JS_LOADED] (state, loaded) {
    state.isAppJsLoaded = loaded
  },
  [CLIENT_USER_INACTIVE_TIMEOUT_IN_MINUTES] (state, value) {
    state.clientUserInactiveTimeoutInMinutes = value
  },
  [IS_APP_LOADING] (state, loading) {
    state.isAppLoading = loading
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js